import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const AthletesServices: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 41.89 43.45">
            <g>
                <path fill={color} d="M11.38,8.03c2.21,0,4.01-1.8,4.01-4.01S13.6,0,11.38,0s-4.01,1.8-4.01,4.01,1.8,4.01,4.01,4.01ZM11.38,1.86c1.19,0,2.15.96,2.15,2.15s-.96,2.15-2.15,2.15-2.15-.96-2.15-2.15.96-2.15,2.15-2.15Z"/>
                <path fill={color} d="M29.43,8.03c2.21,0,4.01-1.8,4.01-4.01s-1.8-4.01-4.01-4.01-4.01,1.8-4.01,4.01,1.8,4.01,4.01,4.01ZM29.43,1.86c1.19,0,2.15.96,2.15,2.15s-.96,2.15-2.15,2.15-2.15-.96-2.15-2.15.96-2.15,2.15-2.15Z"/>
                <path fill={color} d="M37.07,18.58v-7.85h-14.2v7.85h-3.84v-7.85H4.81v7.85H1.97l-1.97,1.86h4.81v10.58h3.15v12.42h1.86v-12.42h3.54v12.42h1.86v-12.42h3.78v-10.58h20.9l1.97-1.86h-4.83ZM17.16,29.16H6.68V12.6h10.48v16.56ZM35.2,18.58h-10.48v-5.98h10.48v5.98Z"/>
            </g>
        </svg>
    );
};

export default AthletesServices;
